import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import HeaderNavbar from "../Component/Navbar";
import Footer from "../Component/Footer";
import { useNavigate } from "react-router-dom";

export default function ReportAbuse() {
  const navigate = useNavigate();
  return (
    <>
      <HeaderNavbar />

      {/* PAGE HEADER */}
      <div
        style={{
          background: "#f8f5f2",
          padding: "60px 0",
          textAlign: "center",
        }}
      >
        <h1 style={{ color: "#7b1e3b", fontWeight: "600" }}>
          Report Abuse
        </h1>

        <p className="text-muted mt-3">
          Help us maintain a safe, respectful and trusted matrimonial
          community.
        </p>
      </div>

      {/* CONTENT */}
      <Container style={{ padding: "70px 0" }}>
        <Row className="justify-content-center">
          <Col lg={10}>
            <Card className="shadow-sm border-0 mb-4">
              <Card.Body>
                <h3 style={{ color: "#7b1e3b" }}>Our Commitment</h3>

                <p className="mt-3">
                  We are committed to providing a safe and secure platform for
                  all members. If you encounter suspicious behavior,
                  inappropriate content, fake profiles or any activity that
                  violates our community guidelines, please report it
                  immediately. Every report is reviewed carefully by our support
                  team.
                </p>
              </Card.Body>
            </Card>

            <Card className="shadow-sm border-0 mb-4">
              <Card.Body>
                <h3 style={{ color: "#7b1e3b" }}>
                  What Should You Report?
                </h3>

                <ul className="mt-3">
                  <li>Fake or duplicate profiles.</li>
                  <li>Profiles using someone else's photographs.</li>
                  <li>Harassment, abusive or offensive messages.</li>
                  <li>Requests for money or financial assistance.</li>
                  <li>Scams or fraudulent activities.</li>
                  <li>Threatening or inappropriate behavior.</li>
                  <li>Spam or promotional messages.</li>
                  <li>Any content that violates our Terms of Service.</li>
                </ul>
              </Card.Body>
            </Card>

            <Card className="shadow-sm border-0 mb-4">
              <Card.Body>
                <h3 style={{ color: "#7b1e3b" }}>
                  How to Report a Member
                </h3>

                <ol className="mt-3">
                  <li>Visit the member's profile.</li>
                  <li>Click the <strong>Report Profile</strong> option.</li>
                  <li>Select the appropriate reason for reporting.</li>
                  <li>Add additional details if required.</li>
                  <li>Submit your report.</li>
                </ol>

                <p className="mb-0">
                  Once submitted, our moderation team will investigate the
                  report and take appropriate action if necessary.
                </p>
              </Card.Body>
            </Card>

            <Card className="shadow-sm border-0 mb-4">
              <Card.Body>
                <h3 style={{ color: "#7b1e3b" }}>
                  Safety Tips
                </h3>

                <ul className="mt-3">
                  <li>Never share your OTP or passwords with anyone.</li>
                  <li>
                    Avoid sending money to someone you have only met online.
                  </li>
                  <li>
                    Verify important information independently before making any
                    commitments.
                  </li>
                  <li>
                    Meet in public places when meeting someone for the first
                    time.
                  </li>
                  <li>
                    Inform your family or trusted friends before meeting a
                    member in person.
                  </li>
                  <li>
                    Report suspicious behavior immediately through the platform.
                  </li>
                </ul>
              </Card.Body>
            </Card>

            <Card
              className="border-0 shadow"
              style={{ background: "#fff8fa" }}
            >
              <Card.Body className="text-center p-5">
                <h3 style={{ color: "#7b1e3b" }}>
                  Need Immediate Assistance?
                </h3>

                <p className="text-muted mt-3 mb-0">
                  If you believe a member is violating our policies or posing a
                  risk to other users, please report the profile immediately or
                  contact our customer support team. We take every report
                  seriously and strive to ensure a safe environment for all
                  members.
                </p>
                <div className="center mt-3">
                  <Button
                    className="about-btn" style={{ width: "200px" }}
                    onClick={() => navigate("/contact")}
                  >
                    Report Us
                  </Button>
                </div>
              </Card.Body>

            </Card>
          </Col>
        </Row>
      </Container>

      <Footer />
    </>
  );
}